import {Button} from 'shells/button/button';

import type {BookingFragment_formSubmission as FormSubmission} from 'nutshell-graphql-types';

import {OpenableModals} from '../../openable-modals/openable-modals';
import {useOpenableModal} from '../../openable-modals/use-openable-modal';

interface Props {
    formSubmission: FormSubmission;
}

export function FormSubmission(props: Props) {
    const {onOpen: onOpenSubmissionModal} = useOpenableModal(OpenableModals.FORM_SUBMISSION_MODAL, {
        submissionId: props.formSubmission.id,
        primaryEntity: props.formSubmission.primaryEntity,
        submissionTime: props.formSubmission.submissionTime,
        form: props.formSubmission.formVersion.form,
    });

    return (
        <Button variant='text-primary' onClick={onOpenSubmissionModal} noPadding={true}>
            All details
        </Button>
    );
}
